function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import isEmpty from 'ramda/src/isEmpty';
import pick from 'ramda/src/pick';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { CreateAddressPopupStateRegionProvinceValueOptions, PostalCodeSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { setAddressData } from '../../../reducers/actions/customer.addresses.actions';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../customer/addresses/addresses.constants';
import { IsAddressMandatoryInCreditCheckSelector } from '../../../reducers/selectors/credit.check.selectors';
import { stateRequiredHelper } from '../../customer/addresses/address.helper';
var AddressInformationSectionController = /*#__PURE__*/function () {
  function AddressInformationSectionController($ngRedux, uiNotificationService) {
    _classCallCheck(this, AddressInformationSectionController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      addressFormModel: {},
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      CoreLocaleKeys: CoreLocaleKeys,
      formMaxLengthValidation: ADDRESS_FORM_FIELD_MAX_LENGTH,
      isCountryDisabled: this.isCountryDisabled || false,
      onAddressFormUpdate: this.onAddressFormUpdate.bind(this),
      pickAddressFormDataFrom: this.pickAddressFormDataFrom.bind(this),
      stateRequired: null,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(AddressInformationSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var promises = [];
      var codeTables = [CODES.AddressCountry, CODES.AddressRequirements, CODES.AddressStateProvinceRegion];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressRequirements: MetadataCodeTypeSelector(CODES.AddressRequirements, store),
          addressStatesOptions: CreateAddressPopupStateRegionProvinceValueOptions(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          isAddressMandatoryInCreditCheck: IsAddressMandatoryInCreditCheckSelector(store),
          postalCode: PostalCodeSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        setAddressData: setAddressData
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          promises.push(_this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          }));
        }
      });
      Promise.all(promises).then(function () {
        _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.state.addressStatesOptions);
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      Object.assign(this.addressFormModel, this.pickAddressFormDataFrom(this.customerModel));
      this.handleFormChanged();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (!isEmpty(this.addressFormModel) && changesObj.customerModel && changesObj.customerModel.currentValue) {
        Object.assign(this.addressFormModel, this.pickAddressFormDataFrom(changesObj.customerModel.currentValue));
      }
    }
  }, {
    key: "onAddressFormUpdate",
    value: function onAddressFormUpdate(addressFormModel) {
      Object.assign(this.customerModel, addressFormModel);
      Object.assign(this.addressFormModel, addressFormModel);
      this.onFormChanged()(this.customerModel);
    }

    //This is a helper function for the address wrapup contextual modal
  }, {
    key: "pickAddressFormDataFrom",
    value: function pickAddressFormDataFrom(model) {
      return pick(['addressLine1', 'addressLine2', 'city', 'country', 'stateRegionProvince', 'postalCode'], model);
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.setAddressData();
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "setAddressData",
    value: function setAddressData() {
      var payload = {};
      if (this.customerModel.country) {
        payload.Country = this.customerModel.country;
      }
      this.actions.setAddressData(payload);
    }
  }, {
    key: "isError",
    value: function isError(formElement) {
      return (formElement.$error.pattern || formElement.$error.required || formElement.$error.maxlength) && (formElement.$touched || this.isFormSubmitted);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.state.isAddressMandatoryInCreditCheck && this.markMandatoryCreditCheckFieldsDisabled;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./address.section.html'),
  bindings: {
    addressStateOptions: '<',
    customerModel: '<',
    isCountryDisabled: '<',
    errorLookup: '<',
    onFormChanged: '&',
    isFormSubmitted: '<',
    markMandatoryCreditCheckFieldsDisabled: '<?'
  },
  controller: AddressInformationSectionController,
  controllerAs: 'AddressInformationSection'
};